(() => {
  if (window.__dtxDingdoongModalBound) return;
  window.__dtxDingdoongModalBound = true;

  const MODAL_SELECTOR = '[data-dtx-dingdoong-modal]';
  const MOUNT_SELECTOR = '[data-dtx-dingdoong-mount]';
  const BODY_SELECTOR = '[data-dtx-dingdoong-modal-body]';
  const CLOSE_SELECTOR = '[data-dtx-dingdoong-modal-close]';
  const CONTINUE_SELECTOR = '[data-dtx-dingdoong-modal-continue]';
  const TRIGGER_SELECTOR =
    '[data-dtx-checkout-trigger], #checkout, #checkout-drawer, .cart__checkout-button[name="checkout"]';
  const ADD_TO_CART_SELECTOR =
    '[name="add"], [data-type="add-to-cart-form"], product-form-component, .buy-btn, .dtx-product-card, product-card';
  const SELECTED_SELECTOR =
    '.ot-dingdoong-calendar__selected, .ot-dingdoong-calendar__day.ot-dingdoong-calendar__selected, .ot-dingdoong-calendar__day-button[aria-pressed="true"], .ot-dingdoong-calendar__day-button[aria-selected="true"]';
  const PLACEHOLDER_PATTERNS = [
    'data de envio',
    'shipping date',
    'escolha uma data',
    'choose a date',
    'escolha uma data e hora',
    'before checkout',
    'finalização da compra',
  ];
  const CLEAR_DATE_PATTERNS = ['limpar data', 'clear selected', 'clear date', 'clear shipping date'];

  let dateCheckTimer = 0;
  let lastFocused = null;
  let mountHome = null;
  let opening = false;

  const getModal = () => document.querySelector(MODAL_SELECTOR);
  const getMount = () => document.querySelector(MOUNT_SELECTOR);
  const getBody = () => document.querySelector(BODY_SELECTOR);
  const getContinue = () => document.querySelector(CONTINUE_SELECTOR);

  const isModalOpen = () => {
    const modal = getModal();
    return modal instanceof HTMLDialogElement && modal.open;
  };

  const hasShippingDateSelected = () => {
    const scope = document.querySelector(`${MODAL_SELECTOR}[open]`) || getMount() || document;
    if (scope.querySelector(SELECTED_SELECTOR)) return true;

    const clearSelected = Array.from(scope.querySelectorAll('button')).some((button) => {
      const label = `${button.textContent || ''} ${button.getAttribute('aria-label') || ''}`.toLowerCase();
      return CLEAR_DATE_PATTERNS.some((pattern) => label.includes(pattern));
    });
    if (clearSelected) return true;

    const button = scope.querySelector('.ot-dingdoong-dropdown__button');
    if (!button) return false;
    const text = button.textContent?.trim().toLowerCase() || '';
    if (!text) return false;
    return !PLACEHOLDER_PATTERNS.some((pattern) => text.includes(pattern));
  };

  const updateContinueState = () => {
    const continueBtn = getContinue();
    if (!(continueBtn instanceof HTMLButtonElement)) return;
    continueBtn.disabled = !hasShippingDateSelected();
  };

  const showNotice = () => {
    const notice = document.querySelector(`${MODAL_SELECTOR} [data-shipping-date-notice]`);
    if (!(notice instanceof HTMLElement)) return;
    notice.hidden = false;
    notice.setAttribute('data-shipping-date-missing', '');
  };

  const hideNotice = () => {
    document.querySelectorAll('[data-shipping-date-notice]').forEach((notice) => {
      if (!(notice instanceof HTMLElement)) return;
      notice.hidden = true;
      notice.removeAttribute('data-shipping-date-missing');
    });
  };

  const releaseScrollLock = () => {
    document.documentElement.classList.remove('dtx-dingdoong-modal-open', 'dtx-scroll-lock');
    document.documentElement.style.overflow = '';
    if (document.body) document.body.style.overflow = '';
  };

  const placeMountInModal = () => {
    const mount = getMount();
    const body = getBody();
    if (!(mount instanceof HTMLElement) || !(body instanceof HTMLElement)) return;
    if (!mountHome) mountHome = mount.parentElement;
    if (!body.contains(mount)) body.appendChild(mount);
    mount.classList.remove('is-parked');
    mount.setAttribute('aria-hidden', 'false');
  };

  const parkMount = () => {
    const mount = getMount();
    if (!(mount instanceof HTMLElement)) return;
    const home = mountHome || document.querySelector('.dtx-dingdoong-host-section') || document.body;
    if (home && mount.parentElement !== home) home.appendChild(mount);
    mount.classList.add('is-parked');
    mount.setAttribute('aria-hidden', 'true');
  };

  const afterCloseCleanup = () => {
    const modal = getModal();
    if (modal instanceof HTMLElement) modal.classList.remove('is-open');
    parkMount();
    releaseScrollLock();
    hideNotice();
    opening = false;
    if (dateCheckTimer) {
      window.clearTimeout(dateCheckTimer);
      dateCheckTimer = 0;
    }
    if (lastFocused && document.contains(lastFocused)) {
      try {
        lastFocused.focus({ preventScroll: true });
      } catch (_) {}
    }
    lastFocused = null;
  };

  const openModal = () => {
    const modal = getModal();
    if (!(modal instanceof HTMLElement)) return false;
    if (modal instanceof HTMLDialogElement && modal.open) return true;
    if (opening) return true;
    opening = true;

    lastFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    // Keep dialog on <body> so it stacks above the cart drawer dialog.
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    placeMountInModal();
    modal.classList.add('is-open');
    document.documentElement.classList.add('dtx-dingdoong-modal-open');

    if (!hasShippingDateSelected()) showNotice();
    else hideNotice();
    updateContinueState();

    if (modal instanceof HTMLDialogElement) {
      try {
        if (!modal.open) modal.showModal();
      } catch (err) {
        // Nested dialog fallback
        modal.setAttribute('open', '');
        modal.style.display = 'flex';
      }
    }

    window.setTimeout(() => {
      const dateBtn = modal.querySelector(
        '#dd-container .ot-dingdoong-dropdown__button, .ot-dingdoong-dropdown__button'
      );
      if (dateBtn instanceof HTMLElement && dateBtn.getAttribute('aria-expanded') !== 'true') {
        try {
          dateBtn.click();
        } catch (_) {}
      }
      updateContinueState();
      opening = false;
    }, 300);

    return true;
  };

  const closeModal = () => {
    const modal = getModal();
    if (modal instanceof HTMLDialogElement && modal.open) {
      try {
        modal.close();
      } catch (_) {
        modal.removeAttribute('open');
        modal.style.display = '';
        afterCloseCleanup();
      }
      return;
    }
    if (modal instanceof HTMLElement) {
      modal.removeAttribute('open');
      modal.style.display = '';
    }
    afterCloseCleanup();
  };

  const DATE_ATTR_RE =
    /attributes\[(?:Local delivery date|Shipping date|Pickup [Dd]ate)\]=/i;

  const getDingdoongCheckoutUrl = () => {
    const url = window.dingdoongQueryParams;
    if (typeof url !== 'string' || !url.includes('/checkout')) return '';
    return url;
  };

  const waitForDingdoongCheckoutUrl = (timeoutMs = 2500) =>
    new Promise((resolve) => {
      const started = Date.now();
      const tick = () => {
        const url = getDingdoongCheckoutUrl();
        if (url && DATE_ATTR_RE.test(url)) {
          resolve(url);
          return;
        }
        if (Date.now() - started >= timeoutMs) {
          resolve(url || '');
          return;
        }
        window.setTimeout(tick, 50);
      };
      tick();
    });

  /** Parse DingDoong checkout query into cart attributes + flush via Ajax. */
  const flushAttributesFromCheckoutUrl = async (checkoutUrl) => {
    try {
      const qs = checkoutUrl.includes('?') ? checkoutUrl.split('?')[1] : '';
      if (!qs) return false;
      const params = new URLSearchParams(qs);
      const attributes = {};
      params.forEach((value, key) => {
        const match = key.match(/^attributes\[(.+)\]$/);
        if (match && value) attributes[match[1]] = value;
      });
      if (!Object.keys(attributes).length) return false;
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      return true;
    } catch (_) {
      return false;
    }
  };

  const navigateToCheckout = (checkoutUrl) => {
    const url = checkoutUrl && DATE_ATTR_RE.test(checkoutUrl) ? checkoutUrl : checkoutUrl || '/checkout';

    // Point cart form at DingDoong's attribute URL (their own hook).
    const form = document.querySelector('form[method="post"]#cart-form, form[method="post"]#cart');
    if (form instanceof HTMLFormElement && url.includes('/checkout')) {
      try {
        form.setAttribute('action', url);
      } catch (_) {}
    }

    window.location.assign(url.startsWith('/') || url.startsWith('http') ? url : `/${url}`);
  };

  /**
   * DingDoong attaches the date via window.dingdoongQueryParams
   * (/checkout?attributes[Local delivery date]=...). Bare /checkout drops it.
   */
  const goToCheckout = () => {
    const modal = getModal();
    const continueBtn = getContinue();
    if (continueBtn instanceof HTMLButtonElement) {
      continueBtn.disabled = true;
    }

    // Soft-hide UI but keep DingDoong mounted so query params stay current.
    if (modal instanceof HTMLElement) {
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('dtx-dingdoong-modal-open');
    }

    waitForDingdoongCheckoutUrl(2500).then(async (checkoutUrl) => {
      if (checkoutUrl && DATE_ATTR_RE.test(checkoutUrl)) {
        await flushAttributesFromCheckoutUrl(checkoutUrl);
      }
      navigateToCheckout(checkoutUrl || '/checkout');
      window.setTimeout(() => {
        if (modal instanceof HTMLDialogElement && modal.open) {
          try {
            modal.close();
          } catch (_) {
            modal.removeAttribute('open');
            afterCloseCleanup();
          }
        } else {
          afterCloseCleanup();
        }
      }, 600);
    });
  };

  const isCheckoutTrigger = (el) => {
    if (!(el instanceof Element)) return false;
    if (el.closest(ADD_TO_CART_SELECTOR)) return false;
    if (el.closest(MODAL_SELECTOR)) return false;
    const trigger = el.closest(TRIGGER_SELECTOR);
    if (!(trigger instanceof HTMLElement)) return false;
    if (trigger.getAttribute('data-dtx-checkout-bypass') === '1') return false;
    if (trigger.getAttribute('name') === 'add') return false;
    return true;
  };

  const onCheckoutAttempt = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!isCheckoutTrigger(target)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const btn = target.closest(TRIGGER_SELECTOR);
    if (btn instanceof HTMLElement) {
      btn.classList.remove('dingdoong-disabled-checkout');
      btn.style.pointerEvents = 'auto';
    }

    openModal();
  };

  const onContinue = () => {
    if (!hasShippingDateSelected()) {
      showNotice();
      updateContinueState();
      return;
    }
    goToCheckout();
  };

  const scheduleDateCheck = () => {
    if (!isModalOpen()) return;
    if (dateCheckTimer) window.clearTimeout(dateCheckTimer);
    dateCheckTimer = window.setTimeout(() => {
      dateCheckTimer = 0;
      updateContinueState();
      if (hasShippingDateSelected()) hideNotice();
    }, 200);
  };

  // Public API for Liquid onclick fallback
  window.dtxOpenShippingDateModal = (event) => {
    if (event) {
      event.preventDefault?.();
      event.stopPropagation?.();
    }
    return openModal();
  };

  const bind = () => {
    const mount = getMount();
    if (mount instanceof HTMLElement) mountHome = mount.parentElement;

    const modal = getModal();
    if (modal instanceof HTMLDialogElement && modal.dataset.dtxDialogBound !== '1') {
      modal.dataset.dtxDialogBound = '1';
      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal();
      });
      modal.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeModal();
      });
      modal.addEventListener('close', afterCloseCleanup);
    }

    if (!isModalOpen()) releaseScrollLock();

    // window capture runs before document/app handlers (DingDoong).
    window.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest(CLOSE_SELECTOR)) {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
        return;
      }

      if (target.closest(CONTINUE_SELECTOR)) {
        event.preventDefault();
        event.stopPropagation();
        onContinue();
        return;
      }

      if (isModalOpen()) {
        if (target.closest('.ot-dingdoong-calendar, .ot-dingdoong-dropdown, #dd-container')) {
          scheduleDateCheck();
        }
        return;
      }

      onCheckoutAttempt(event);
    }, true);

    window.addEventListener(
      'submit',
      (event) => {
        const submitter = event.submitter;
        if (submitter && isCheckoutTrigger(submitter)) {
          onCheckoutAttempt(event);
        }
      },
      true
    );

    window.addEventListener(
      'keydown',
      (event) => {
        if (event.key === 'Escape' && isModalOpen()) {
          event.preventDefault();
          closeModal();
        }
      },
      true
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
